import React, { useState } from 'react';
import { AnalyticsEventSource } from '@atlassian/temp-analytics';
import { useParams } from 'react-router-dom';
import { useTitle } from '@css-xp/ppc-custom-hooks';
import { PPC_PAGE_TITLE, routePaths } from '@css-xp/ppc-constants';
import { AppContent, AppPage, useApplicationContext } from '@css-xp/base';
import { ScreenEventAnalytics } from '@css-xp/ppc-common';
import { PageBackgroundV2 } from '@css-xp/page-background';
import { DealRegistrationsTable } from './components/deal-registrations-table';
import './deal-registrations-page.scss';

export const DealRegistrationsPage = () => {
  useTitle(PPC_PAGE_TITLE.DEAL_REGISTRATIONS);

  const renderAppPage = () => {
    return (
      <AppPage className="app-page-v2 deal-registrations-page" allowedSidebars={{}}>
        <AppContent>
          <ScreenEventAnalytics
            event={{
              name: AnalyticsEventSource.PARTNER_DEAL_REGISTRATIONS_SCREEN,
              attributes: {},
            }}
          />
          <section className="ph-50 mb-50 deal-registrations-page-table">
            <DealRegistrationsTable />
          </section>
        </AppContent>
      </AppPage>
    );
  };

  const renderPage = () => {
    const breadcrumbsItems = [
      {
        title: 'Home',
        href: routePaths.home,
      },
      {
        title: 'Deals',
        href: routePaths.dealRegistrations,
      },
    ];

    return (
      <PageBackgroundV2
        heading={'Deals'}
        breadcrumbsProps={{ items: breadcrumbsItems }}
        className="deal-registrations-page-background"
      >
        {renderAppPage()}
      </PageBackgroundV2>
    );
  };

  return renderPage();
};
